<template>
  <div id="wrapAndrInstall">
    <p>Для установки приложения вы можете выбрать один из представленных способов.</p>
    <ul>
      <li>
        <p>- Используя системное сообщение внизу экрана</p>
      </li>
      <li :style="{'display': installBtn}">
        <p>- Нажмите на кнопку</p>
        <button @click="installer()" :style="{'display': installBtn}">Установить приложение</button>
      </li>
      <li>
        <p>- Через меню браузера,<br/>что бы добавить приложение<br/>следуйте инструкции.</p>
        <img id="gifImg" src="/img/gif/androidInstall.gif" alt="Пример установки, через меню браузера" loop=infinite>
      </li>
    </ul>
    <p>Как только приложение будет установленно, оно появится на вашем домашнем экране и в списке приложений.</p>

  </div>
</template>

<script>
  export default {
    name: "androidPwaInstall",
    data() {
      return {
        installBtn: 'none'
      }
    },
    created() {
      try {
        //кнопка установки в хроме и на андройде
        let installPromt;
        window.addEventListener('beforeinstallprompt', e => {
          e.preventDefault();
          installPromt = e;
          this.installBtn = 'block';
        });
        this.installer = () => {
          this.installBtn = 'none';
          installPromt.prompt();
          installPromt.userChoice.then(result => {
            if (result.outcome === 'accepted') {
              console.log('User accepted');
            } else {
              console.log('User denied');
            }
            installPromt = null;
          });
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
</script>

<style scoped>
  ul, li {
    margin: 0;
    padding: 2vw;
    list-style: none;
  }

  #wrapAndrInstall {
    padding: 0 2vw;
  }
  #gifImg{width: 60vw;margin: 2vw 0;}
  li p{margin: 0;padding: 0;text-align: left}
</style>
